import React from 'react';
import Hero from '../components/Hero';
import Card from '../components/Card';
import { Heart, Shield, Clock, TrendingUp, Users, Target, UserCheck, Activity, Award, Briefcase, Zap } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Insurance.css';

const LifeInsurance = () => {
    const { t } = useLanguage();

    const lifePlans = [
        { key: 'ft_life_term', icon: Clock, desc: 'Highest coverage at lowest premium. Pure protection for your family.' },
        { key: 'ft_life_whole', icon: Heart, desc: 'Coverage for a lifetime with maturity benefits and legacy building.' },
        { key: 'ft_life_endow', icon: Target, desc: 'Regular savings combined with a life cover for guaranteed returns.' },
        { key: 'ft_life_money', icon: TrendingUp, desc: 'Periodic survival benefits during the term to meet liquidity needs.' },
        { key: 'ft_life_ulip', icon: Activity, desc: 'Wealth creation through market-linked returns plus life insurance.' },
        { key: 'ft_life_child', icon: Users, desc: 'Dedicated plan to fund your child\'s education and major milestones.' },
        { key: 'ft_life_pension', icon: UserCheck, desc: 'Retire in comfort with guaranteed regular income for your golden years.' },
    ];

    return (
        <div className="insurance-page">
            <Hero 
                title={t('ft_life')}
                subtitle="Life is a journey of responsibilities. Secure every step of your family's future with our elite life insurance portfolio."
                bgGradient={true}
                image="/assets/life-hero.png"
            />

            <section className="section-padding container">
                <div className="text-center mb-60">
                    <h2 className="section-title">Select Your Protection Plan</h2>
                    <p className="section-subtitle">A diverse range of life insurance solutions designed for wealth, protection, and retirement.</p>
                </div>
                
                <div className="grid grid-3">
                    {lifePlans.map((plan, i) => (
                        <Card 
                            key={i}
                            title={t(plan.key)}
                            description={plan.desc}
                            icon={plan.icon}
                            link="/contact"
                        />
                    ))}
                </div>
            </section>

            <section className="features-grid section-padding" style={{ background: '#F8F9FA' }}>
                <div className="container">
                    <div className="text-center mb-60">
                        <h2 className="section-title">Why Life Insurance?</h2>
                    </div>
                    <div className="grid grid-2">
                        <div className="feature-item">
                            <Award className="feature-icon" />
                            <h4>Tax Benefits</h4>
                            <p>Save under Section 80C and enjoy tax-free returns under Section 10(10D) of Income Tax Act.</p>
                        </div>
                        <div className="feature-item">
                            <Zap className="feature-icon" />
                            <h4>Loan Facility</h4>
                            <p>Borrow against your life insurance policy during financial emergencies at low interest rates.</p>
                        </div>
                        <div className="feature-item">
                            <Briefcase className="feature-icon" />
                            <h4>Financial Independence</h4>
                            <p>Ensure your family continues their lifestyle and pays off liabilities in your absence.</p>
                        </div>
                        <div className="feature-item">
                            <Shield className="feature-icon" />
                            <h4>Peace of Mind</h4>
                            <p>Focus on your life today knowing your tomorrow is professionally protected.</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container text-center section-padding">
                <div className="cta-box glass">
                    <h3>Need Help Choosing the Right Plan?</h3>
                    <p>Our life insurance experts are just a call away for a free consultation.</p>
                    <button className="btn btn-primary" onClick={() => window.location.href='/contact'}>Talk to an Expert</button>
                </div>
            </div>
        </div>
    );
};

export default LifeInsurance;
